import OctApiAdaptor from '@/components/api-adaptor/OctApiAdaptor.js'
import {getCSV} from '@/components/artwork/OctArtwork'
import OctTags from '@/components/tags/OctTags.js'

// Properties
const props = {
  /** Id */
  id: {
    type: String,
    default: ''
  },
  /** Exhibition type */
  type: {
    type: String,
    default: 'physical'
  },
  /** Exhibition title */
  title: {
    type: String,
    default: ''
  },
  /** Exhibition title in English */
  titleEN: {
    type: String,
    default: ''
  },
  /** Start Date */
  startDate: {
    type: String,
    default: ''
  },
  /** End Date */
  endDate: {
    type: String,
    default: ''
  },
  /** Organizer of the exhibition */
  gallery: {
    type: Object,
    default: () => {}
  },
  /** Exhibition images */
  images: {
    type: Array,
    default: () => []
  },
  /** Description */
  description: {
    type: String,
    default: ''
  },
  /** Description in English */
  descriptionEN: {
    type: String,
    default: ''
  },
  /** List of exhibited work */
  artworks: {
    type: Array,
    default: () => []
  },
  /** List of participating artist */
  artists: {
    type: Array,
    default: () => []
  },
  /** List of artfair the exhibition will be held */
  artFairs: {
    type: Array,
    default: () => []
  },
  /** List of venue */
  venues: {
    type: Array,
    default: () => []
  },
  /** List of platform */
  platforms: {
    type: Array,
    default: () => []
  },
  /** Organizers */
  organizers: {
    type: Array,
    default: () => []
  },
  /** Sponsers */
  sponsers: {
    type: Array,
    default: () => []
  },
  /** Note */
  note: {
    type: String,
    default: ''
  },
  /** Note in English */
  noteEN: {
    type: String,
    default: ''
  },
  /** Related articles */
  articles: {
    type: Array,
    default: () => []
  },
  /** Tags */
  tags: {
    type: Array,
    default: () => [] 
  },
  /** Extra data */
  data: {
    type: [String, Object],
    default () {
      return {
        publicArtworks: []
      }
    }
  },
  /** Public staus */
  status: {
    type: String,
    default: 'private'
  }
}

export const createProps = () => {
  return Object.keys(props).reduce((acc, cur) => {
    acc[cur] = typeof props[cur].default === 'function' ?
      props[cur].default() : props[cur].default
    return acc
  }, {})
}

// Create computed property
const computed = Object.keys(props).reduce((acc, cur) => {
  acc[`$_octExhibition_${cur}`] = {
    get () {
      return this[cur]
    },
    set (val) {
      this.$emit(`update:${cur}`, val)
    }
  }
  return acc
}, {})

// Override computed functions
computed['$_octExhibition_status'] = {
  get () {
    return this.status === 'private'
  },
  set (val) {
    this.$emit('update:status', val ? 'private' : 'public')
  }
}

export default {
  name: 'OctExhibition',
  props: props,
  data () {
    return {
      categories: OctTags
    }
  },
  computed: {
    /** Categoris by slug */
    categoriesBySlug () {
      return this.categories.reduce((acc, cur) => {
        acc[cur.slug] = cur
        return acc
      }, {})
    },
    ...computed
  },
  methods: {
    /**
     * Return CSV string of artworks in the news
     * @param {string} token - Auth0 token
     */
    async toCSV (token) {
      // CSV strings to return
      let csv = []
      // Promises to fetch artwork details
      const promises = []

      // Fetch all artworks in the exhibition
      const artworks = (await OctApiAdaptor.getArtworks({
        exhibition: this.id,
        count: 100
      }, token)).items

      // Fetch all artworks details
      artworks.forEach(item => {
        promises.push(
          OctApiAdaptor.getArtwork(item.id, token)
        )
      })

      const items = await Promise.all(promises)

      // Create CSV
      items.forEach(item => {
        csv.push(`${getCSV(item)}`)
      })

      return csv.join('\n')
    },
  }
}
